import { render, staticRenderFns } from "./TeacherStudent.vue?vue&type=template&id=29e18c12"
import script from "./TeacherStudent.vue?vue&type=script&lang=js"
export * from "./TeacherStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports